import { useState, useMemo } from 'react';
import { usePageMeta, useSchemaOrg } from '@/hooks/usePageMeta';
import PageShell from '@/components/feature/PageShell';
import ProductCard from '@/components/feature/ProductCard';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories } from '@/mocks/categories';
import { products } from '@/mocks/products';

export default function Categories() {
  const [activeCategory, setActiveCategory] = useState(categories[0].id);

  usePageMeta({
    title: '品类展示 - 精品水蜜桃礼盒 | 鲜摘蜜桃 | 时令限定 | 美丽的小蜜桃',
    description: '美丽的小蜜桃品类展示：精品水蜜桃礼盒、鲜摘蜜桃、水果礼篮、时令限定。精选阳山、龙泉驿、奉化三大核心产区，优质水蜜桃产地直发，新鲜蜜桃礼盒装。',
    keywords: '水蜜桃礼盒装,新鲜蜜桃礼盒,精品桃子采购,鲜摘蜜桃,水蜜桃产地直发,时令限定蜜桃',
    canonicalUrl: 'https://meilixiaomitao.com/categories',
  });

  useSchemaOrg({
    organization: true,
    website: true,
    webpage: true,
    breadcrumb: [
      { name: '首页', url: 'https://meilixiaomitao.com/' },
      { name: '品类展示', url: 'https://meilixiaomitao.com/categories' },
    ],
  });

  const filteredProducts = useMemo(
    () => products.filter((p) => p.categoryId === activeCategory),
    [activeCategory]
  );

  const activeCategoryData = categories.find((c) => c.id === activeCategory);

  return (
    <PageShell>
      <div className="pt-24 pb-16 md:pb-20 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '品类展示' },
              ]}
            />
          </div>

          <div className="text-center mb-10">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              品类展示
            </h1>
            <p className="text-foreground-500 text-sm md:text-base">
              精选多款水蜜桃产品，满足不同场合需求
            </p>
          </div>

          {/* Category Tabs */}
          <div className="flex justify-center mb-12">
            <div className="inline-flex flex-wrap justify-center gap-2 bg-background-100 rounded-full px-1 py-1">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                    activeCategory === cat.id
                      ? 'bg-background-50 text-primary-600 shadow-sm'
                      : 'text-foreground-500 hover:text-foreground-800'
                  }`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${cat.icon} text-xs`}></i>
                  </div>
                  {cat.name}
                </button>
              ))}
            </div>
          </div>

          {/* Category Description */}
          {activeCategoryData && (
            <div className="text-center mb-10">
              <p className="text-foreground-500 text-sm max-w-lg mx-auto">
                {activeCategoryData.description}
              </p>
            </div>
          )}

          {/* Products Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6" data-product-shop>
            {filteredProducts.map((product) => (
              <ProductCard key={product.id} {...product} />
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="text-center py-16">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-4xl text-foreground-300"></i>
              </div>
              <p className="text-foreground-400 text-sm">该品类暂无产品，敬请期待</p>
            </div>
          )}
        </div>
      </div>
    </PageShell>
  );
}